import React, { Component } from 'react';

class TicketPage extends Component {
    render() {
        return (
            <div className="flex items-center">
                <p className="mr-5">{(this.props.page === 1 && this.props.total === 0) ? 0 : this.props.limit * (this.props.page - 1) + 1}-{this.props.limit * this.props.page > this.props.total ? this.props.total : this.props.limit * this.props.page} of {this.props.total}</p>
            </div>
        );
    }
}

export default TicketPage;